module.exports = __webpack_public_path__ + "media/images/lb/769-7ad9ba442efb38d12ae566b2dcb7816d.svg";